import { ReactNode, useMemo } from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { interfaceTokenVariables, resolveInterfaceTokens } from './brandTokens';

/** React theme scope also reaches portaled dialogs without global document styles. */
export default function CompanyActionThemeScope({ configuration, children }: {
  configuration?: unknown;
  children: ReactNode;
}) {
  const parent = useTheme();
  const theme = useMemo(() => {
    const button = parent.components?.MuiButton;
    const base = parent.components?.MuiButtonBase;
    const variables = interfaceTokenVariables(resolveInterfaceTokens(configuration));
    return {
      ...parent,
      components: {
        ...parent.components,
        MuiButtonBase: {
          ...base,
          styleOverrides: { ...base?.styleOverrides, root: [base?.styleOverrides?.root, variables] }
        },
        MuiButton: {
          ...button,
          styleOverrides: {
            ...button?.styleOverrides,
            root: [button?.styleOverrides?.root, variables]
          }
        }
      }
    };
  }, [parent, configuration]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
